import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IEmpresa } from './interfaces/empresa.interface';
import { EmpresaService } from './services/empresa.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-lista-empresas',
  templateUrl: './lista-empresas.component.html',
  providers: [MessageService]
})
export class ListaEmpresasComponent implements OnInit {
  empresas: IEmpresa[] = [];
  selectedEmpresa: IEmpresa | null = null;
  displayDialog: boolean = false;
  loading: boolean = false;
  searchTerm: string = '';
  currentPage: number = 1;
  pageSize: number = 10;
  totalRecords: number = 0;
  first: number = 0;

  displayedColumns = [
    { field: 'identificador', header: 'Clave Empresa', sortable: true },
    { field: 'nombre', header: 'Nombre Empresa', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private empresaService: EmpresaService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const request = {
      que: 4,
      tope: "9999",
      identificador: this.searchTerm,
      nombre: this.searchTerm,
      calle: '',
      numext: '',
      numint: '',
      ciudad: '',
      del_muni: '',
      cve_estado: '',
      estatus: '',
      telefono: '',
      telefono2: '',
      scoring: 0,
      politica: '',
      comentario: ''
    };

    this.empresaService.getEmpresas(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.empresas = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cargar las empresas'
          });
        }
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar las empresas'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedEmpresa = null;
    this.displayDialog = true;
  }

  openUpdate(empresa: IEmpresa): void {
    this.selectedEmpresa = empresa;
    this.displayDialog = true;
  }

  openDelete(empresa: IEmpresa): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar esta empresa?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.empresaService.deleteEmpresa(empresa.identificador).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Empresa eliminada correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar la empresa'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar la empresa'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.selectedEmpresa = null;
  }

  onPage(event: any): void {
    this.currentPage = event.page + 1;
    this.first = event.first;
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
      this.displayDialog = false;
      this.loadData();
    }
  }

  onSearch(): void {
    this.currentPage = 1;
    this.loadData();
  }
} 